'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RaisedButton = require('./RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RaisedButton2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/RaisedButton/index.js
 ** module id = 853
 ** module chunks = 0
 **/